<div class="max-card-dialog-info">
  <div class="p-0">
    <div class="text-primary d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <span class="font-weight-bold">
          {{ dialogDataSearch.title }}
        </span>
        <mat-icon class="ml-3">search</mat-icon>
      </div>
      <button
        pButton
        pRipple
        mat-dialog-close
        icon="pi pi-times-circle"
        class="p-button-danger p-button-rounded p-button-text mb-2 mr-2"
      ></button>
    </div>
    <div class="d-md-flex justify-content-md-between align-items-center">
      <div class="width-100 d-flex justify-content-md-start align-items-center">
        <div
          [class]="keywordcontrol.class"
          *ngFor="let keywordcontrol of dialogDataSearch.fields"
        >
          <span
            class="p-float-label p-input-icon-right width-100"
            *ngIf="
              keywordcontrol.type !== 'status' && keywordcontrol.type !== 'data'
            "
          >
            <i
              *ngIf="keywordcontrol.control.value"
              (click)="clearFilter(keywordcontrol.control)"
              id="search-keyword"
              class="text-danger pi pi-fw pi-times-circle cursor-pointer"
            >
            </i>
            <input
              type="text"
              id="inputtext-right"
              pInputText
              [formControl]="keywordcontrol.control"
              (keyup)="enterSearch($event)"
              class="input-filters"
            />
            <label for="inputtext-right">{{ keywordcontrol.label }}</label>
          </span>
          <p-dropdown
            *ngIf="keywordcontrol.type === 'status'"
            [(ngModel)]="keywordcontrol.selectedValue"
            [formControl]="keywordcontrol.control"
            [options]="keywordcontrol.selectOptions"
            [placeholder]="keywordcontrol.label"
            optionLabel="viewValue"
            (onChange)="onSearch()"
            [showClear]="true"
            (onClear)="clearFilter(keywordcontrol.control)"
          >
          </p-dropdown>
          <p-calendar
            *ngIf="keywordcontrol.type === 'data'"
            dateMask
            [placeholder]="keywordcontrol.label"
            [formControl]="keywordcontrol.control"
            dateFormat="dd/mm/yy"
            [maxDate]="maxDate"
            (onSelect)="onSearch()"
            (keyup)="enterSearch($event)"
            [showIcon]="true"
            inputId="icon"
          >
          </p-calendar>
          <i
            *ngIf="
              keywordcontrol.control.value && keywordcontrol.type === 'data'
            "
            (click)="clearFilter(keywordcontrol.control)"
            id="search-keyword"
            class="ml-2 text-danger pi pi-fw pi-times-circle cursor-pointer"
          >
          </i>
        </div>
      </div>
      <div class="flex mb-3 align-items-center justify-content-end">
        <button
          pButton
          pRipple
          [disabled]="disabledClear"
          icon="pi pi-search"
          (click)="onSearch()"
          class="p-button-primary p-button-rounded p-button-outlined mr-2"
        ></button>
        <button
          pButton
          pRipple
          icon="pi pi-filter-slash"
          [disabled]="disabledClear"
          (click)="onClearKeyword()"
          class="p-button-danger p-button-rounded p-button-outlined mr-2"
        ></button>
      </div>
    </div>
  </div>
  <div class="app-loading" *ngIf="loading">
    <h4 class="text-splash">
      Buscando resultados, por-favor aguarde!
    </h4>
    <div class="content-spinner">
      <svg class="spinner" viewBox="25 25 50 50">
        <circle
          class="path"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          stroke-width="2"
          stroke-miterlimit="10"
        />
      </svg>
    </div>
  </div>

  <div *ngIf="!loading && noResults">
    <h4 class="text-center font-weight-light d-flex justify-content-center">
      Nenhum resultado encontrado, filtre novamente!
    </h4>
  </div>

  <div *ngIf="!loading && !noResults && !useTableExpanded">
    <div class="flex align-items-center justify-content-start">
      <button
        pButton
        pRipple
        label="Selecionar"
        icon="pi pi-check-circle"
        class="p-button-primary p-button-rounded p-button-text mb-2 mr-2"
        [disabled]="
          selectOnlyOne
            ? !(table && table.selectedEntities.length === 1)
            : !(table && table.selectedEntities.length !== 0)
        "
        (click)="
          matDialogRef.close(
            selectOnlyOne ? table.selectedEntities[0] : table.selectedEntities
          )
        "
      ></button>
      <button
        pButton
        pRipple
        label="Adicionar novo"
        icon="pi pi-plus-circle"
        class="p-button-primary p-button-rounded p-button-text mb-2 mr-2"
        [disabled]="!(table && table.selectedEntities.length === 0)"
        *ngIf="addBtn"
        (click)="openDialogFast()"
      ></button>
    </div>
    <viggo-core-grid-table
      #table
      [data]="filterEntities"
      [columnDefs]="columnDefs"
      [noResults]="noResults"
      [disableCheckbox]="false"
      [statusSelected]="statusEntities"
      [showReorderColumns]="false"
      [loading]="loading"
      [menu]="entityName"
      [moduleName]="moduleName"
      [showReorderColumns]="false"
      [showExportData]="false"
      [showImportData]="false"
      [showErrorMessage]="errorResponse"
      [errorMessage]="getMessageError()"
      [errorTitle]="errorResponse?.title"
      [first]="getFirstConfigPagination()"
      [rows]="rows"
      [pageLength]="pageLength"
      [KEY_DATA_SELECTION]="KEY_DATA_SELECTION"
      [KEY_DATA_NOT_SELECTION]="KEY_DATA_NOT_SELECTION"
      [KEY_DATA_ALL_SELECTED]="KEY_DATA_ALL_SELECTED"
      [paginatorPageIndex]="page"
      (onHandlePage)="handlePage($event)"
    ></viggo-core-grid-table>
  </div>
  <div *ngIf="!loading && !noResults && useTableExpanded">
    <div class="flex align-items-center justify-content-start">
      <button
        pButton
        pRipple
        label="Selecionar"
        icon="pi pi-check-circle"
        class="p-button-primary p-button-rounded p-button-text mb-2 mr-2"
        [disabled]="
          !(
            tableExpanded &&
            selectedEntities &&
            selectedItensEntities &&
            (selectedEntities.length !== 0 ||
              selectedItensEntities.length !== 0)
          )
        "
        (click)="
          matDialogRef.close({
            entities: dataSelection,
            subEntities: dataItensSelection
          })
        "
      ></button>
      <button
        pButton
        pRipple
        label="Adicionar novo"
        icon="pi pi-plus-circle"
        class="p-button-primary p-button-rounded p-button-text mb-2 mr-2"
        [disabled]="
          !(
            tableExpanded &&
            selectedEntities &&
            selectedItensEntities &&
            selectedEntities.length === 0 &&
            selectedItensEntities.length === 0
          )
        "
        *ngIf="addBtn"
        (click)="openDialogFast()"
      ></button>
    </div>
    <p-table
      #tableExpanded
      dataKey="id"
      styleClass="p-datatable-customers"
      selectionMode="multiple"
      [value]="filterEntities"
      [rowHover]="true"
      [(selection)]="dataSelection"
      (selectionChange)="selectionEntities($event)"
      (onRowUnselect)="rowUnselect($event)"
    >
      <ng-template pTemplate="header">
        <tr>
          <span class="item"></span>
          <th style="width: 3rem" pResizableColumn></th>
          <th style="width: 3rem" pResizableColumn>
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th
            *ngFor="let col of columnDefs"
            pResizableColumn
            [pSortableColumn]="col.sortable ? col.field_sortable : null"
          >
            <div class="flex align-items-center justify-content-between">
              <div>
                <span>{{ col.headerName }}</span>
              </div>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-entity let-expanded="expanded">
        <tr
          [ngClass]="{ 'item-inative': !entity.active }"
          class="p-datatable-tbody"
        >
          <span class="item"></span>
          <td>
            <button
              type="button"
              pButton
              pRipple
              [pRowToggler]="entity"
              class="p-button-text p-button-rounded p-button-plain"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
            ></button>
          </td>
          <td>
            <p-tableCheckbox [value]="entity"></p-tableCheckbox>
          </td>
          <td
            *ngFor="let col of columnDefs"
            [pSelectableRow]="entity"
            [pRowToggler]="entity"
          >
            <span class="p-column-title">{{ col.headerName }}</span>
            {{
              col.cellRenderer ? col.cellRenderer(entity) : entity[col.field]
            }}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-entity>
        <tr>
          <td colspan="7">
            <div class="p-3">
              <p-table
                #tableEntitiesExpanded
                [value]="entity.itens"
                selectionMode="multiple"
                [selectionPageOnly]="true"
                [rowHover]="true"
                styleClass="p-datatable-customers"
                (selectionChange)="selectionItens($event)"
                [(selection)]="dataItensSelection"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <span class="item"></span>
                    <th style="width: 3rem" pResizableColumn>
                      <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th
                      *ngFor="let col of itensColumnDefs"
                      pResizableColumn
                      [pSortableColumn]="
                        col.sortable ? col.field_sortable : null
                      "
                    >
                      <div
                        class="flex align-items-center justify-content-between"
                      >
                        <div>
                          <span>{{ col.headerName }}</span>
                        </div>
                      </div>
                    </th>
                  </tr>
                </ng-template>
                <ng-template
                  pTemplate="body"
                  let-subEntity
                  let-rowIndex="rowIndex"
                >
                  <tr [ngClass]="{ 'item-inative': !subEntity.active }">
                    <span class="item"></span>
                    <td>
                      <p-tableCheckbox [value]="subEntity"></p-tableCheckbox>
                    </td>
                    <td
                      *ngFor="let col of itensColumnDefs"
                      [pSelectableRow]="subEntity"
                      [pSelectableRowIndex]="rowIndex"
                    >
                      <span class="p-column-title">{{ col.headerName }}</span>
                      {{
                        col.cellRenderer
                          ? col.cellRenderer(subEntity)
                          : subEntity[col.field]
                      }}
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="6">Não possui nenhum item relacionado...</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <p-paginator
          (onPageChange)="handlePageTableExpanded($event)"
          [first]="first"
          [rows]="page_size"
          [totalRecords]="pageLength"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Exibindo {first} - {last} do total de {totalRecords}"
          [rowsPerPageOptions]="pageSizeOptions"
        ></p-paginator>
      </ng-template>
    </p-table>
  </div>
</div>
